import React from 'react';
import updateResourceLink from '../../utils/updateResourceLink';
import styles from './ResourceLink.css';

const ResourceLink = (props) => {
    const {
        link: { link, name, replaceCusip, replaceTrpCode, replaceFundName },
        cusip,
        trpCode,
        ticker,
        id,
        extraClass
    } = props;
    const formattedLink = updateResourceLink(
        link,
        cusip,
        trpCode,
        replaceCusip,
        replaceTrpCode,
        replaceFundName,
        ticker
    );
    return (
        <div>
            <a
                rel="noopener noreferrer"
                target="_blank"
                className={`resource-link ${extraClass || ''}`}
                href={formattedLink}
                id={id || `${name}-${trpCode}`}
            >
                {name}
            </a>
            <style jsx>{styles}</style>
        </div>
    );
};

export default ResourceLink;
